import styled from "@emotion/styled";
import type { PropsWithChildren } from "react";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;

  border-top: ${({ theme }) => `1px solid ${theme.outlineSoft}`};

  flex: 0 0 56px;
  width: 100%;

  padding: 0 10px;
  margin-block-start: auto;
`;

export const Buttons = ({ children }: PropsWithChildren) => <Container>{children}</Container>;
